import React, { ReactElement, useEffect, useRef } from 'react';
import { Form, Modal } from 'react-bootstrap';
import './VoiceGuestNotice.scss';
import { LiveProps } from '../../LiveContainer';
import { MediaDevice } from '../LiveSettings/LiveSettings';
import { toast } from 'react-toastify';
import AgoraRTC, { IMicrophoneAudioTrack } from 'agora-rtc-sdk-ng';
import { RtmMessage } from 'agora-rtm-sdk';
import { MessageType } from '../../types/messageType';

export const VoiceGuestNoticeModal = (props: LiveProps): ReactElement => {
  const microphoneTrackRef = useRef<IMicrophoneAudioTrack>();
  useEffect(() => {
    AgoraRTC.getDevices()
      .then((devices) => {
        const listInputDevice = devices.map((device) => {
          const temp: MediaDevice = {
            id: device.deviceId,
            name: device.label,
            kind: device.kind,
          };
          return temp;
        });
        props.updateListMediaDevicesGuest(listInputDevice);
      })
      .catch(() => {
        toast.error('Fail to access media devices');
      });
    listenChannelMessage();
  }, [props.liveState.isInLive]);

  const publishMicrophone = async () => {
    props.liveState.rtcEngine?.instance?.setClientRole('host').then(() => {
      AgoraRTC.createMicrophoneAudioTrack({
        microphoneId: props.liveState.inputAudioDeviceGuest,
        encoderConfig: 'high_quality_stereo',
      }).then((micTrack) => {
        microphoneTrackRef.current = micTrack;
        props.liveState.rtcEngine?.publishStream(micTrack);
      });
    });
  };
  const listenChannelMessage = () => {
    props.liveState.rtmEngine?.on(
      'ChannelMessage',
      (message: RtmMessage): void => {
        if (message.messageType === 'TEXT') {
          const content = JSON.parse(message.text);
          // hot end pair
          if (content.type === MessageType.END_PAIR) {
            unpublishedMicrophone();
          }
        }
      },
    );
  };
  const unpublishedMicrophone = async () => {
    const microphoneTrack = microphoneTrackRef.current;
    if (microphoneTrack) {
      await props.liveState.rtcEngine?.unpublishStream(microphoneTrack);
      microphoneTrack.close();
      microphoneTrackRef.current = undefined;
      await props.liveState.rtcEngine?.instance?.setClientRole('audience');
    }
  };

  const onSelectAudioInput = (event: any) => {
    const value =
      event.target.value !== 'None' ? event.target.value : undefined;
    props.changeAudioInputGuest(value);
  };

  const handleToggleNotice = () => {
    publishMicrophone();
    props.toggleNoticeApprovePairModal(false);
  };

  return (
    <Modal
      show={props.liveState.isShowNoticePairModal}
      centered
      size="sm"
      backdrop="static"
      className="voice-guest-notice-modal"
    >
      <div className="voice-guest-notice-modal-wrapper">
        <img
          src={props.liveState.liveData?.user.picture.uri}
          alt=""
          className="voice-guest-notice-modal-body-img"
        />
        <div className="voice-guest-notice-modal-body-question">
          {props.liveState.liveData?.user.loginId}{' '}
          さんからペア配信に招待されました！
        </div>
        <Form.Select
          id="live-setting__audio-input"
          onChange={(event) => onSelectAudioInput(event)}
          value={props.liveState.inputAudioDeviceGuest}
        >
          <>
            <option>None</option>
            {props.liveState.mediaDevicesGuest
              .filter((device) => device.kind === 'audioinput')
              .map((device, index) => (
                <option key={index} value={device.id}>
                  {device.name}
                </option>
              ))}
          </>
        </Form.Select>
        <button
          onClick={handleToggleNotice}
          type="button"
          className="voice-guest-notice-modal-body-btn"
        >
          OK
        </button>
      </div>
    </Modal>
  );
};
